import React from 'react';
import PropTypes from 'prop-types';

function DividerWithText({ text }) {
  const dividerClasses = 'w-50 bt-0 bb b--light-gray bl-0 br-0';
  return (
    <div className="tc flex justify-center pv4">
      <hr className={dividerClasses} />
      <p className="ph2 secondary">{text}</p>
      <hr className={dividerClasses} />
    </div>
  );
}

DividerWithText.propTypes = {
  text: PropTypes.string.isRequired
};

export default DividerWithText;
